module.exports = __webpack_public_path__ + "img/button.b834a12c.png";